/*
 * Copyright (c) 2020 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */
import logger from '@getgo/logger';
import type { Logger } from '@getgo/logger';
import loggerTargetLoggingServicePlugin from '@getgo/logger-target-logging-service';
import * as platform from 'platform';
import {LOGGER_CONFIG} from '../Constants';
import {getVersion} from './Utils';

let applicationRootLogger: Logger | null = null;

export const createLogger = (module: string): any => {
    const rootLogger = getRootLogger();
    return rootLogger.create(module);
};

const getRootLogger = (): any => {
    if (!applicationRootLogger) {
        applicationRootLogger = logger.createRoot(process.env.JEST_WORKER_ID !== undefined ? [] : loggerTargetLoggingServicePlugin(LOGGER_CONFIG));
        setCommonLoggerContext(applicationRootLogger);
    }
    return applicationRootLogger;
};

const setCommonLoggerContext = (currentLogger: Logger) => {
    currentLogger.setContext('buildVersion', getVersion());
    currentLogger.setContext('app', 'Device Activation Portal');
    currentLogger.setContext('browser', {
        'name': platform.name,
        'version': platform.version,
        'os.family': platform.os.family,
        'os.version': platform.os.version,
        'language': navigator.language,
    });
};
